import type { AppIconName } from "@shared/ui/chakra/data-display/icon/icon.tsx";

import { isFiatIcon } from "@shared/libs/crypto/guards";
import { fiatCurrencyIcons } from "@shared/libs/crypto/maps";

import {
  cryptoCurrencyIcons,
  cryptoNetworkIcons,
  isCryptoIcon,
  isNetworkIcon,
} from ".";

export const getIconName = (code: string): AppIconName => {
  if (isCryptoIcon(code)) {
    return cryptoCurrencyIcons[code];
  }
  if (isFiatIcon(code)) {
    return fiatCurrencyIcons[code];
  }
  return "CryptoOther";
};

export const getNetworkIcon = (slug: string): AppIconName => {
  if (isNetworkIcon(slug)) {
    return cryptoNetworkIcons[slug];
  }
  return "CryptoOther";
};
